import { ITitleTextButton } from './types';

export const mapTitleTextButton = ({
  prismicContent: { primary },
}): ITitleTextButton => {
  const {
    button_label: buttonLabel,
    internal_link: internalLink,
    external_link: externalLink,
    white_background: whiteBackground,
  } = primary;

  return {
    ...primary,
    buttonLabel,
    link: internalLink || externalLink!.url,
    whiteBackground,
  };
};
